import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
      {//调查问卷
        path: '/dcwj',
        name: 'dcwj',
        component:resolve => require(['@/components/dialog/Dcwj'], resolve),
      },
      {
        path: '/login',
        name: 'login',
        component:resolve => require(['@/view/user/login'], resolve),
           
      },
      {
        path: '/MobileFace',
        name: 'MobileFace',
        component:resolve => require(['@/components/mobile/MobileFace'], resolve),
           
      },
      {
        path: '/GXKCheckCredit',
        name: '/GXKCheckCredit',
        component:resolve => require(['@/view/credit/GXKCheckCredit'], resolve),
      },
      {
          path: '/consent',
          name: 'consent',
          component:resolve => require(['@/view/user/consent'], resolve),
            
      },
      {
        path: '/PrintGXK',
        name: 'PrintGXK',
        component:resolve => require(['@/components/PrintGXK'], resolve),
      },
      // {
      //   path: '/PrintGXK2024',
      //   name: 'PrintGXK2024',
      //   component:resolve => require(['@/components/PrintGXK2024'], resolve),
      // },
    {
      path: '/EnrollChoose',
      name: 'EnrollChoose',
      component:resolve => require(['@/view/enroll/EnrollChoose'], resolve),
    },
    {
      path: '/PrintView',
      name: 'PrintView',                                                                                 
      
      component:resolve => require(['@/view/user/PrintView'], resolve),
    },
    {
      path: '/PrintView2024',
      name: 'PrintView2024',
      component:resolve => require(['@/view/user/PrintView2024'], resolve),
    },
    {
      path: '/xfCard',
      name: 'xfCard',
      component:resolve => require(['@/view/xuefen/xfCard'], resolve),
    },
    // {
    //   path: '/MemberView',
    //   name: 'MemberView',
    //   component:resolve => require(['@/view/member/MemberView'], resolve),
    //   redirect: {name:'MemberCard'},
    //   children: [
    //     {
    //       path: 'MemberCard',
    //       name: 'MemberCard',
    //       component:resolve => require(['@/view/member/MemberCard'], resolve),
    //     },
    //     {
    //       path: 'MemberMessage',
    //       name: 'MemberMessage',
    //       component:resolve => require(['@/view/member/MemberMessage'], resolve),
    //     },
    //     {
    //       path: 'MemberFinish',
    //       name: 'MemberFinish',
    //       component:resolve => require(['@/view/member/MemberFinish'], resolve),
    //     }
    //   ]
    // },
{
  path: '/Enroll',
  name: 'Enroll',
  component:resolve => require(['@/view/enroll/Enroll'], resolve),
  redirect: {name:'EnrollView'},
  children: [
    {
      path: 'EnrollView',
      name: 'EnrollView',
      component:resolve => require(['@/view/enroll/EnrollView'], resolve),
    },
    
    {
      path: 'EnrollCourse',
      name: 'EnrollCourse',
      component:resolve => require(['@/view/enroll/EnrollCourse'], resolve),
    },
    {
      path: 'EnrollRegister',
      name: 'EnrollRegister',
      component:resolve => require(['@/view/enroll/EnrollRegister'], resolve),
    },
    {
      path: 'EnrollMessage',
      name: 'EnrollMessage',
      component:resolve => require(['@/view/enroll/EnrollMessage'], resolve),
    },
    {
      path: 'EnrollPay',
      name: 'EnrollPay',
      component:resolve => require(['@/view/enroll/EnrollPay'], resolve),
    },
    {
      path: 'EnrollFinish',
      name: 'EnrollFinish',
      component:resolve => require(['@/view/enroll/EnrollFinish'], resolve),
    }
  ]
},
  {
    path: '/UserView',
    name: 'UserView',
    component:resolve => require(['@/view/user/UserView'], resolve),
    redirect: {name:'UserMessage'},
    children: [
      {
        path: 'HomeView',
        name: 'HomeView',
        component:resolve => require(['@/view/user/HomeView'], resolve),
      },
      {
        path: 'UserMessage',
        name: 'UserMessage',
        component:resolve => require(['@/view/user/UserMessage'], resolve),
      },
      {
        path: 'CourseList',
        name: 'CourseList',
        component:resolve => require(['@/view/user/CourseList'], resolve),
      },
      {
        path: '/CourseDetail/:id',
        name: 'CourseDetail',
        component:resolve => require(['@/view/user/CourseDetail'], resolve),
      },
      {
        path: '/OnlineTest/:id',
        name: 'OnlineTest',
        component:resolve => require(['@/view/user/OnlineTest'], resolve),
      },
      { 
        path: 'results',
        name: 'results',
        component:resolve => require(['@/view/user/results'], resolve),
      },
      { 
        path: 'CreditInquiry',
        name: 'CreditInquiry',
        component:resolve => require(['@/view/user/CreditInquiry'], resolve),
      },
      { 
        path: 'QuestionView',
        name: 'QuestionView',
        component:resolve => require(['@/view/user/QuestionView'], resolve),
      },
      {
          path: '/ResetPwd',
          name: 'ResetPwd',
          component:resolve => require(['@/view/user/ResetPwd'], resolve),
        }
    ]
  },
  {
    path: '/',
    name: 'Content',
    component:resolve => require(['@/view/content/Content'], resolve),
    redirect: {name:'Index'},
    children: [
      {
        path: 'Index',
        name: 'Index',
        component:resolve => require(['@/view/content/Index'], resolve),
        // component: Index,
        meta: {
            requireAuth: true,
            // keepAlive: true // 用户列表需要被缓存
        }
      },
      {
        path: 'ImportantQuestion',
        name: 'ImportantQuestion',
        component:resolve => require(['@/view/content/ImportantQuestion'], resolve),
      },
      {
        path: '/Search/:id',
        name: 'Search',
        component:resolve => require(['@/view/content/Search'], resolve),
      },
       {
        path: '/List/:id',
        name: 'List',
        component:resolve => require(['@/view/content/List'], resolve),
      },
      {
        path: 'Article',
        name: 'Article',
        component:resolve => require(['@/view/content/Article'], resolve),
      },
    //   {
    //     path: '/Article/:num',
    //     name: 'Article',
    //     component:resolve => require(['@/view/content/Article'], resolve),
    //   },
      {
        path: 'Association',
        name: 'Association',
        component:resolve => require(['@/view/content/Association'], resolve),
      },
      {
        path: 'AboutUs',
        name: 'AboutUs',
        component:resolve => require(['@/view/content/AboutUs'], resolve),
      }
    ]
  }
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js